import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { GalleryService } from '../../services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryResolve {
  private galleryService = inject(GalleryService);

  async resolve(next: ActivatedRouteSnapshot) {
    try {
      return await this.galleryService.getPublicGalleryFromSnapshot(next);
    } catch (err) {
      console.error(err);
    }
  }
}
